/**
 * DemoOverlay — Disclaimer banner shown at the top of chart containers
 * for users on the DEMO subscription tier.
 */

// Bug E, Task 6: since aggregates are now full-population (Task 4), real
// per-point graying on the scatter is no longer meaningful — the lock
// affordance lives here instead, as a discreet hint (not heavy per-point
// ECharts icons). Clicking through to a cell's own detail page is still
// gated by the WS 1.3 daily-limit click-through guard in
// RadarSectionPage.jsx's chart click handler.
function LockGlyph() {
  return (
    <svg
      className="radar-demo-overlay__lock"
      width="11"
      height="11"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      aria-hidden="true"
    >
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  )
}

export default function DemoOverlay() {
  return (
    <div className="radar-demo-overlay">
      <span className="radar-demo-overlay__icon">i</span>
      <span className="radar-demo-overlay__text">
        You're seeing the full market picture — every measured cell is on this
        chart. Unlock per-cell detail with PRO.
      </span>
      <span className="radar-demo-overlay__lock-hint" title="Per-cell detail is PRO">
        <LockGlyph />
        <span className="radar-demo-overlay__lock-label">PRO</span>
      </span>
    </div>
  )
}
